module.exports = __webpack_public_path__ + "static/media/2020-12-16-01.ad362d42.jpg";